export default __webpack_public_path__ + "static/media/itEssensial.fbfebb83.jpeg";